export default "__VITE_ASSET__BP_gs5yO__"